import Axios from 'axios';
import {store} from '../../store/';

export const Dashboard = {
  fetchDashboardInfo(name) {
    return Axios.get(`/hospitals/${store.state.user.active_user.ref}/dashboards/${name}`);
  }
};